import { render } from "./ModalDelete.vue?vue&type=template&id=2ac20229&scoped=true"
import script from "./ModalDelete.vue?vue&type=script&lang=js"
export * from "./ModalDelete.vue?vue&type=script&lang=js"

import "./ModalDelete.vue?vue&type=style&index=0&id=2ac20229&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac20229"]])

export default __exports__